/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.1
 */

/**
 * Type of animal
 */
export type CreateReportDtoAnimalType =
  (typeof CreateReportDtoAnimalType)[keyof typeof CreateReportDtoAnimalType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateReportDtoAnimalType = {
  vertebrate: 'vertebrate',
  invertebrate: 'invertebrate',
} as const;
